import { Tile } from '#src/components/boards/HotStreakTile/Tile/index.tsx';
import {
  DiamondBaseColor,
  DiamondBasePosition,
} from '#src/components/boards/HotStreakTile/Tile/utils.ts';

type Props = {
  gold?: boolean;
  pending?: boolean;
};
export const ClaimableTile = ({ gold = false, pending = false }: Props) => {
  if (pending) {
    return (
      <Tile
        color={DiamondBaseColor.gray}
        diamondBaseColor={DiamondBaseColor.blue}
        position={DiamondBasePosition.up}
        floating
      />
    );
  }

  return (
    <Tile
      color={gold ? DiamondBaseColor.gold : DiamondBaseColor.blue}
      position={DiamondBasePosition.up}
      floating
    />
  );
};
